import { useState } from 'react';
import { supa } from '../lib/supabase.js';
import { TH, CATS, PLANS, NBS, NBP } from '../lib/constants.js';
import { pushToast, compressImage } from '../lib/helpers.js';
import { updateProfileAvatar, updateProfileCover, updateProfileBio, uploadAvatarToStorage, uploadCoverToStorage, fetchFullUserExport } from '../lib/api.js';
import { Av, Toggle, SectionLabel } from '../components/Basic.jsx';
import { SettingsRow } from '../components/SettingsShared.jsx';
import { t as tr } from '../lib/i18n.js';
export function SettingsView({t,theme,st,dispatch,go,userId,userEmail}){
  const [cat,setCat]=useState(CATS[0]);
  const [bioEdit,setBioEdit]=useState(false);
  const [bioVal,setBioVal]=useState(st.profile.bio||"");
  const saveBio=async()=>{
    dispatch({type:"SET_BIO",bio:bioVal});
    setBioEdit(false);
    if(userId){
      const ok=await updateProfileBio(userId,bioVal);
      if(!ok) pushToast(dispatch,tr("set_toast_bio_offline"));
    }
  };
  const [showTimePicker,setShowTimePicker]=useState(false);
  const [showThemePicker,setShowThemePicker]=useState(false);
  const [showStylePicker,setShowStylePicker]=useState(false);
  const [showPaperPicker,setShowPaperPicker]=useState(false);
  const [showPasswordChange,setShowPasswordChange]=useState(false);
  const [exporting,setExporting]=useState(false);
  const handleExport=async()=>{
    if(exporting)return;
    setExporting(true);
    if(userId){
      const fresh=await fetchFullUserExport(userId);
      const blob=new Blob([JSON.stringify(fresh,null,2)],{type:"application/json"});
      const url=URL.createObjectURL(blob);
      const a=document.createElement("a");
      a.href=url; a.download=`oncer-dati-${(st.profile.username||"utente")}.json`;
      document.body.appendChild(a); a.click(); document.body.removeChild(a);
      URL.revokeObjectURL(url);
    } else {
      exportUserData(st); // rete non disponibile / account non collegato: usa quello che c'è in locale
    }
    setExporting(false);
  };
  const [pw1,setPw1]=useState("");
  const [pw2,setPw2]=useState("");
  const [pwErr,setPwErr]=useState("");
  const [pwBusy,setPwBusy]=useState(false);
  const savePassword=async()=>{
    setPwErr("");
    if(pw1.length<6){ setPwErr(tr("set_pw_err_short")); return; }
    if(pw1!==pw2){ setPwErr(tr("set_pw_err_mismatch")); return; }
    setPwBusy(true);
    const {error}=await supa.auth.updateUser({password:pw1});
    setPwBusy(false);
    if(error){ setPwErr(error.message); return; }
    setShowPasswordChange(false); setPw1(""); setPw2("");
    pushToast(dispatch,tr("set_toast_pw_updated"));
  };
  const [uploadingAvatar,setUploadingAvatar]=useState(false);
  const [uploadingCover,setUploadingCover]=useState(false);
  const set=st.settings;
  const currentThemeName=(TH[theme]||TH.neon).name;
  const currentStyleName=(NBS[st.nbStyle]||Object.values(NBS)[0])?.name||"—";
  const currentPaperName=(NBP[st.nbPaper]||Object.values(NBP)[0])?.name||"—";
  const handleAvatarPick=async(e)=>{
    const file=e.target.files&&e.target.files[0];
    e.target.value="";
    if(!file||!userId)return;
    setUploadingAvatar(true);
    try{
      const dataUrl=await new Promise((resolve,reject)=>{
        const reader=new FileReader();
        reader.onload=()=>resolve(reader.result);
        reader.onerror=()=>reject(new Error("lettura immagine fallita"));
        reader.readAsDataURL(file);
      });
      const compressedBlob=await compressImage(dataUrl,500,0.85);
      const url=await uploadAvatarToStorage(compressedBlob,userId);
      const ok=await updateProfileAvatar(userId,url);
      if(ok) dispatch({type:"SET_PROFILE",data:{avatarUrl:url}});
      else pushToast(dispatch,tr("set_toast_avatar_save_fail"));
    }catch(err){
      console.error("Oncer: caricamento foto profilo fallito —",err.message);
      pushToast(dispatch,tr("set_toast_avatar_upload_fail"));
    }
    setUploadingAvatar(false);
  };
  const handleCoverPick=async(e)=>{
    const file=e.target.files&&e.target.files[0];
    e.target.value="";
    if(!file||!userId)return;
    setUploadingCover(true);
    try{
      const dataUrl=await new Promise((resolve,reject)=>{
        const reader=new FileReader();
        reader.onload=()=>resolve(reader.result);
        reader.onerror=()=>reject(new Error("lettura immagine fallita"));
        reader.readAsDataURL(file);
      });
      const compressedBlob=await compressImage(dataUrl,1200,0.82);
      const url=await uploadCoverToStorage(compressedBlob,userId);
      const ok=await updateProfileCover(userId,url);
      if(ok) dispatch({type:"SET_PROFILE",data:{coverUrl:url}});
      else pushToast(dispatch,tr("set_toast_cover_save_fail"));
    }catch(err){
      console.error("Oncer: caricamento copertina fallito —",err.message);
      pushToast(dispatch,tr("set_toast_cover_upload_fail"));
    }
    setUploadingCover(false);
  };
  return(
    <div className="screen fade" style={{background:t.bg}}>
      <div style={{padding:"14px 16px 11px",display:"flex",alignItems:"center",gap:11,borderBottom:`1px solid ${t.bord}`,flexShrink:0,background:t.card}}>
        <div onClick={()=>go("profile_me")} style={{width:32,height:32,borderRadius:"50%",background:t.bord,display:"flex",alignItems:"center",justifyContent:"center",cursor:"pointer",fontSize:14,color:t.tx}}>←</div>
        <span style={{fontSize:17,fontWeight:800,color:t.tx,fontFamily:"Inter,sans-serif"}}>{tr("set_header_title")}</span>
      </div>
      <div style={{padding:"4px 16px 40px",flex:1}}>
        <div style={{display:"flex",justifyContent:"center",padding:"10px 0 4px"}}>
          <label style={{position:"relative",cursor:"pointer"}}>
            <input type="file" accept="image/*" style={{display:"none"}} onChange={handleAvatarPick} disabled={uploadingAvatar}/>
            <Av u={st.profile.username||"tu"} tid={theme} sz={84} photo={st.profile.avatarUrl}/>
            <div style={{position:"absolute",bottom:0,right:0,width:28,height:28,borderRadius:"50%",background:t.pill,display:"flex",alignItems:"center",justifyContent:"center",fontSize:13,boxShadow:`0 0 0 2.5px ${t.bg}`}}>{uploadingAvatar?"⏳":"✏️"}</div>
          </label>
        </div>
        <div style={{textAlign:"center",fontSize:11,color:t.soft,fontFamily:"Inter,sans-serif",marginBottom:16}}>{uploadingAvatar?tr("set_avatar_uploading"):tr("set_avatar_hint")}</div>
        <label style={{display:"block",cursor:"pointer",marginBottom:16}}>
          <input type="file" accept="image/*" style={{display:"none"}} onChange={handleCoverPick} disabled={uploadingCover}/>
          <div style={{height:70,borderRadius:14,overflow:"hidden",position:"relative",background:st.profile.coverUrl?"transparent":t.card,border:`1px solid ${t.bord}`,display:"flex",alignItems:"center",justifyContent:"center"}}>
            {st.profile.coverUrl&&<img src={st.profile.coverUrl} style={{position:"absolute",inset:0,width:"100%",height:"100%",objectFit:"cover"}}/>}
            <div style={{position:"relative",zIndex:1,display:"flex",alignItems:"center",gap:7,padding:"6px 14px",borderRadius:20,background:st.profile.coverUrl?"rgba(0,0,0,.5)":"transparent"}}>
              <span style={{fontSize:14}}>{uploadingCover?"⏳":"🖼️"}</span>
              <span style={{fontSize:11.5,fontWeight:600,color:st.profile.coverUrl?"#fff":t.soft,fontFamily:"Inter,sans-serif"}}>{uploadingCover?tr("set_avatar_uploading"):st.profile.coverUrl?tr("set_cover_change"):tr("set_cover_add")}</span>
            </div>
          </div>
        </label>
        <SectionLabel t={t}>{tr("set_sec_account")}</SectionLabel>
        <div style={{background:t.card,borderRadius:14,padding:"2px 12px",border:`1px solid ${t.bord}`}}>
          <SettingsRow t={t} icon="👤" label={tr("set_row_username")} sub={"@"+(st.profile.username||"tu")}/>
          <div style={{padding:"12px 4px",borderBottom:`1px solid ${t.bord}`}}>
            <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:bioEdit?8:0}}>
              <div style={{width:32,fontSize:17,textAlign:"center",flexShrink:0}}>📝</div>
              <div style={{flex:1}}>
                <div style={{fontSize:14,fontWeight:600,color:t.tx,fontFamily:"Inter,sans-serif"}}>{tr("set_row_bio")}</div>
                {!bioEdit&&<div style={{fontSize:11,color:t.soft,fontFamily:"Inter,sans-serif",marginTop:2}}>{st.profile.bio||tr("set_bio_empty")}</div>}
              </div>
              <div onClick={()=>setBioEdit(!bioEdit)} style={{fontSize:12,color:"#FF2D6B",fontWeight:700,fontFamily:"Inter,sans-serif",cursor:"pointer"}}>{bioEdit?tr("set_bio_cancel"):tr("set_bio_edit")}</div>
            </div>
            {bioEdit&&(
              <div style={{display:"flex",gap:8,marginTop:6}}>
                <input value={bioVal} onChange={e=>setBioVal(e.target.value)} onKeyDown={e=>{if(e.key==="Enter")saveBio();}} maxLength={60} placeholder={tr("set_bio_placeholder")} style={{flex:1,border:"1px solid #ddd",borderRadius:9,padding:"8px 10px",fontSize:16,fontFamily:"Inter,sans-serif"}}/>
                <div onClick={saveBio} style={{background:"#FF2D6B",color:"#fff",borderRadius:9,padding:"8px 14px",fontSize:12,fontWeight:700,fontFamily:"Inter,sans-serif",cursor:"pointer",display:"flex",alignItems:"center"}}>{tr("set_bio_save")}</div>
              </div>
            )}
          </div>
          <SettingsRow t={t} icon="✉️" label={tr("set_row_email")} sub={userEmail||"—"}/>
          <SettingsRow t={t} icon="🔑" label={tr("set_row_change_password")} onClick={()=>setShowPasswordChange(true)}/>
        </div>
        <SectionLabel t={t}>{tr("set_sec_notifications")}</SectionLabel>
        <div style={{background:t.card,borderRadius:14,padding:"2px 12px",border:`1px solid ${t.bord}`}}>
          <SettingsRow t={t} icon="🔔" label={tr("set_row_daily_notif")} sub={tr("set_daily_notif_sub",{time:set.notifTime})} onClick={()=>setShowTimePicker(true)}/>
          <SettingsRow t={t} icon="📲" label={tr("set_row_push_notif")} right={<Toggle on={set.pushNotif} onClick={()=>dispatch({type:"UPDATE_SETTINGS",data:{pushNotif:!set.pushNotif}})}/>}/>
          <SettingsRow t={t} icon="📧" label={tr("set_row_email_notif")} right={<Toggle on={set.emailNotif} onClick={()=>dispatch({type:"UPDATE_SETTINGS",data:{emailNotif:!set.emailNotif}})}/>}/>
        </div>
        <SectionLabel t={t}>{tr("set_sec_privacy")}</SectionLabel>
        <div style={{background:t.card,borderRadius:14,padding:"2px 12px",border:`1px solid ${t.bord}`}}>
          <SettingsRow t={t} icon="📖" label={tr("set_row_library_public")} sub={tr("set_library_public_sub")} right={<Toggle on={set.libraryPublic} onClick={()=>dispatch({type:"UPDATE_SETTINGS",data:{libraryPublic:!set.libraryPublic}})}/>}/>
          <SettingsRow t={t} icon="💬" label={tr("set_row_who_message")} sub={set.whoCanMessage==="everyone"?tr("set_who_everyone"):tr("set_who_following")} onClick={()=>dispatch({type:"UPDATE_SETTINGS",data:{whoCanMessage:set.whoCanMessage==="everyone"?"following":"everyone"}})}/>
          <SettingsRow t={t} icon="🚫" label={tr("set_row_blocked_users")} sub={tr("set_blocked_none")} right={<span style={{fontSize:9,padding:"3px 9px",borderRadius:20,background:t.bord,color:t.soft,fontFamily:"Inter,sans-serif",fontWeight:700}}>{tr("set_soon_badge")}</span>}/>
        </div>
        <SectionLabel t={t}>{tr("set_sec_data")}</SectionLabel>
        <div style={{background:t.card,borderRadius:14,padding:"2px 12px",border:`1px solid ${t.bord}`}}>
          <SettingsRow t={t} icon="📥" label={tr("set_row_export")} sub={exporting?tr("set_export_preparing"):tr("set_export_sub")} onClick={handleExport}/>
          <SettingsRow t={t} icon="ℹ️" label={tr("set_row_data_location")} sub={tr("set_data_location_sub")} onClick={()=>go("privacy")}/>
        </div>
        <SectionLabel t={t}>{tr("set_sec_customization")}</SectionLabel>
        <div style={{background:t.card,borderRadius:14,padding:"2px 12px",border:`1px solid ${t.bord}`}}>
          <SettingsRow t={t} icon="🎨" label={tr("set_row_theme")} sub={currentThemeName} onClick={()=>setShowThemePicker(true)}/>
          <SettingsRow t={t} icon="🛠" label={tr("set_row_edit_library")} sub={tr("set_edit_library_sub")} onClick={()=>go("shelf_editor")}/>
          <SettingsRow t={t} icon="✏️" label={tr("set_row_nb_style")} sub={currentStyleName} onClick={()=>setShowStylePicker(true)}/>
          <SettingsRow t={t} icon="📄" label={tr("set_row_nb_paper")} sub={currentPaperName} onClick={()=>setShowPaperPicker(true)}/>
        </div>
        <SectionLabel t={t}>{tr("set_sec_subscription")}</SectionLabel>
        <div style={{background:t.card,borderRadius:14,padding:"2px 12px",border:`1px solid ${t.bord}`}}>
          <SettingsRow t={t} icon="✨" label={tr("set_row_plan")} sub={tr("set_plan_sub",{plan:PLANS.find(p=>p.id===set.plan)?.name})} onClick={()=>go("subscription")}/>
        </div>
        <SectionLabel t={t}>{tr("set_sec_style")}</SectionLabel>
        <div style={{background:t.card,borderRadius:14,padding:"2px 12px",border:`1px solid ${t.bord}`}}>
          <SettingsRow t={t} icon="🎞" label={tr("set_row_filters")} sub={tr("set_filters_sub")} onClick={()=>go("filters")}/>
        </div>
        <SectionLabel t={t}>{tr("set_sec_print")}</SectionLabel>
        <div style={{background:t.card,borderRadius:14,padding:"2px 12px",border:`1px solid ${t.bord}`}}>
          <SettingsRow t={t} icon="🖨" label={tr("set_row_print")} sub={tr("set_print_sub")} onClick={()=>go("print_hub")}/>
        </div>
        {st.profile.isAdmin&&(
          <>
            <SectionLabel t={t}>{tr("set_sec_admin")}</SectionLabel>
            <div style={{background:t.card,borderRadius:14,padding:"2px 12px",border:`1px solid ${t.bord}`}}>
              <SettingsRow t={t} icon="🛡" label={tr("set_row_moderation")} sub={tr("set_moderation_sub")} onClick={()=>go("moderation")}/>
            </div>
          </>
        )}
        <SectionLabel t={t}>{tr("set_sec_info")}</SectionLabel>
        <div style={{background:t.card,borderRadius:14,padding:"2px 12px",border:`1px solid ${t.bord}`}}>
          <SettingsRow t={t} icon="📄" label={tr("set_row_terms")} onClick={()=>go("terms")}/>
          <SettingsRow t={t} icon="🔒" label={tr("set_row_privacy_policy")} onClick={()=>go("privacy")}/>
          <SettingsRow t={t} icon="💌" label={tr("set_row_feedback")} onClick={()=>{window.location.href="mailto:hello@oncer.app?subject=Feedback%20Oncer";}}/>
          <SettingsRow t={t} icon="ℹ️" label={tr("set_row_version")} sub="Oncer Beta 0.9.0" right={<span/>}/>
        </div>
        <SectionLabel t={t}>{tr("set_sec_account")}</SectionLabel>
        <div style={{background:t.card,borderRadius:14,padding:"2px 12px",border:`1px solid ${t.bord}`}}>
          <SettingsRow t={t} icon="🚪" label={tr("set_row_logout")} onClick={async()=>{if(confirm(tr("set_logout_confirm"))){await supa.auth.signOut();location.reload();}}}/>
          <SettingsRow t={t} icon="🗑" label={tr("set_row_delete_account")} danger onClick={async()=>{if(confirm(tr("set_delete_confirm"))){await supa.auth.signOut();localStorage.clear();location.reload();}}}/>
        </div>
      </div>
      {showTimePicker&&(
        <div className="overlay" onClick={()=>setShowTimePicker(false)}>
          <div className="sheet" onClick={e=>e.stopPropagation()}>
            <div style={{display:"flex",justifyContent:"center",padding:"11px 0 4px"}}><div style={{width:36,height:4,borderRadius:2,background:"rgba(0,0,0,.12)"}}/></div>
            <div style={{padding:"5px 16px 12px",display:"flex",alignItems:"center",justifyContent:"space-between"}}>
              <span style={{fontSize:15,fontWeight:800,color:t.tx,fontFamily:"Inter,sans-serif"}}>{tr("set_time_sheet_title")}</span>
              <span onClick={()=>setShowTimePicker(false)} style={{cursor:"pointer",fontSize:20,color:"#aaa"}}>✕</span>
            </div>
            <div style={{padding:"0 16px 26px",display:"flex",flexDirection:"column",gap:9}}>
              {["07:00","09:00","12:00","18:00","20:00","22:00"].map(time=>(
                <div key={time} onClick={()=>{dispatch({type:"UPDATE_SETTINGS",data:{notifTime:time}});setShowTimePicker(false);}} style={{background:set.notifTime===time?"#FFF0F4":"#fafafa",borderRadius:12,padding:"13px 15px",border:set.notifTime===time?"1.5px solid #FF2D6B":"1px solid #eee",display:"flex",alignItems:"center",justifyContent:"space-between",cursor:"pointer"}}>
                  <span style={{fontSize:14,fontWeight:set.notifTime===time?700:400,color:t.tx,fontFamily:"Inter,sans-serif"}}>{time}</span>
                  {set.notifTime===time&&<span style={{color:"#FF2D6B",fontSize:18}}>✓</span>}
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
      {showThemePicker&&(
        <div className="overlay" onClick={()=>setShowThemePicker(false)}>
          <div className="sheet" onClick={e=>e.stopPropagation()} style={{maxHeight:"82vh",display:"flex",flexDirection:"column"}}>
            <div style={{display:"flex",justifyContent:"center",padding:"11px 0 4px",flexShrink:0}}><div style={{width:36,height:4,borderRadius:2,background:"rgba(0,0,0,.12)"}}/></div>
            <div style={{padding:"5px 16px 12px",display:"flex",alignItems:"center",justifyContent:"space-between",flexShrink:0}}>
              <span style={{fontSize:15,fontWeight:800,color:t.tx,fontFamily:"Inter,sans-serif"}}>{tr("set_theme_sheet_title")}</span>
              <span onClick={()=>setShowThemePicker(false)} style={{cursor:"pointer",fontSize:20,color:"#aaa"}}>✕</span>
            </div>
            <div style={{padding:"0 16px",flex:1,overflowY:"auto"}}>
              <div style={{display:"flex",gap:6,overflowX:"auto",scrollbarWidth:"none",marginBottom:10,paddingBottom:2}}>
                {CATS.map(c=><div key={c} onClick={()=>setCat(c)} style={{flexShrink:0,padding:"5px 10px",borderRadius:20,cursor:"pointer",background:cat===c?"#1a1a1a":"rgba(0,0,0,.06)",fontSize:10,fontFamily:"Inter,sans-serif",fontWeight:700,color:cat===c?"#fff":"#555"}}>{c}</div>)}
              </div>
              <div style={{display:"flex",flexWrap:"wrap",gap:8,paddingBottom:22}}>
                {cat===tr("cat_aggiuntivi")&&Object.values(TH).filter(x=>x.cat===tr("cat_aggiuntivi")&&!(st.rewards.unlocked||[]).includes(x.id)).length===Object.values(TH).filter(x=>x.cat===tr("cat_aggiuntivi")).length&&(
                  <div style={{fontSize:12,color:"#888",fontFamily:"Inter,sans-serif",lineHeight:1.6,padding:"6px 2px"}}>{tr("set_theme_locked_hint")}</div>
                )}
                {Object.values(TH).filter(x=>x.cat===cat).filter(x=>x.cat!==tr("cat_aggiuntivi")||(st.rewards.unlocked||[]).includes(x.id)).map(x=>{
                  const act=theme===x.id;
                  return <div key={x.id} onClick={()=>dispatch({type:"SET_THEME",theme:x.id})} style={{display:"flex",flexDirection:"column",alignItems:"center",gap:4,cursor:"pointer",width:54}}>
                    <div style={{width:38,height:38,borderRadius:10,background:x.pill,display:"flex",alignItems:"center",justifyContent:"center",fontSize:17,boxShadow:act?`0 0 0 3px #fff,0 0 0 5px ${x.ac}`:"none"}}>{x.emoji}</div>
                    <div style={{fontSize:8,fontFamily:"Inter,sans-serif",textAlign:"center",color:act?"#FF2D6B":"#888",fontWeight:act?700:400,lineHeight:1.2}}>{x.name}</div>
                  </div>;
                })}
              </div>
            </div>
          </div>
        </div>
      )}
      {showStylePicker&&(
        <div className="overlay" onClick={()=>setShowStylePicker(false)}>
          <div className="sheet" onClick={e=>e.stopPropagation()} style={{maxHeight:"82vh",display:"flex",flexDirection:"column"}}>
            <div style={{display:"flex",justifyContent:"center",padding:"11px 0 4px",flexShrink:0}}><div style={{width:36,height:4,borderRadius:2,background:"rgba(0,0,0,.12)"}}/></div>
            <div style={{padding:"5px 16px 12px",display:"flex",alignItems:"center",justifyContent:"space-between",flexShrink:0}}>
              <span style={{fontSize:15,fontWeight:800,color:t.tx,fontFamily:"Inter,sans-serif"}}>{tr("set_style_sheet_title")}</span>
              <span onClick={()=>setShowStylePicker(false)} style={{cursor:"pointer",fontSize:20,color:"#aaa"}}>✕</span>
            </div>
            <div style={{padding:"0 16px 22px",flex:1,overflowY:"auto",display:"flex",flexDirection:"column",gap:7}}>
              {Object.values(NBS).map(s=>{
                const act=st.nbStyle===s.id;
                return(
                  <div key={s.id} onClick={()=>{dispatch({type:"SET_NB_STYLE",style:s.id});setShowStylePicker(false);}} style={{background:act?"#FDFAF3":"#fafafa",border:act?`1.5px solid ${s.col}`:"1px solid #eee",borderRadius:11,padding:"9px 12px",cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"space-between"}}>
                    <div>
                      <div style={{fontSize:12,fontWeight:700,color:t.tx,fontFamily:"Inter,sans-serif"}}>{s.name}</div>
                      <div style={{fontFamily:s.font,fontSize:s.sz-2,color:s.col,fontStyle:s.sl,marginTop:2}}>{tr("set_style_sample")}</div>
                    </div>
                    {act&&<span style={{color:s.col,fontSize:15}}>✓</span>}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      )}
      {showPaperPicker&&(
        <div className="overlay" onClick={()=>setShowPaperPicker(false)}>
          <div className="sheet" onClick={e=>e.stopPropagation()}>
            <div style={{display:"flex",justifyContent:"center",padding:"11px 0 4px"}}><div style={{width:36,height:4,borderRadius:2,background:"rgba(0,0,0,.12)"}}/></div>
            <div style={{padding:"5px 16px 12px",display:"flex",alignItems:"center",justifyContent:"space-between"}}>
              <span style={{fontSize:15,fontWeight:800,color:t.tx,fontFamily:"Inter,sans-serif"}}>{tr("set_paper_sheet_title")}</span>
              <span onClick={()=>setShowPaperPicker(false)} style={{cursor:"pointer",fontSize:20,color:"#aaa"}}>✕</span>
            </div>
            <div style={{padding:"0 16px 26px",display:"flex",gap:8,overflowX:"auto",scrollbarWidth:"none"}}>
              {Object.values(NBP).map(p=>{
                const act=st.nbPaper===p.id;
                return(
                  <div key={p.id} onClick={()=>{dispatch({type:"SET_NB_PAPER",paper:p.id});setShowPaperPicker(false);}} style={{flexShrink:0,width:70,background:p.bg,borderRadius:11,border:act?`2px solid ${p.mg}`:`1px solid ${p.line}`,padding:"10px 8px",cursor:"pointer",textAlign:"center"}}>
                    <div style={{fontSize:11,fontWeight:700,fontFamily:"Inter,sans-serif",color:p.id==="night"?"#fff":"#1a1a1a",marginBottom:4}}>{p.name}</div>
                    {act&&<span style={{fontSize:12,color:p.mg}}>✓</span>}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      )}
      {showPasswordChange&&(
        <div className="overlay" onClick={()=>{setShowPasswordChange(false);setPw1("");setPw2("");setPwErr("");}}>
          <div className="sheet" onClick={e=>e.stopPropagation()}>
            <div style={{display:"flex",justifyContent:"center",padding:"11px 0 4px"}}><div style={{width:36,height:4,borderRadius:2,background:"rgba(0,0,0,.12)"}}/></div>
            <div style={{padding:"5px 16px 12px",display:"flex",alignItems:"center",justifyContent:"space-between"}}>
              <span style={{fontSize:15,fontWeight:800,color:"#1a1a1a",fontFamily:"Inter,sans-serif"}}>{tr("set_pw_sheet_title")}</span>
              <span onClick={()=>{setShowPasswordChange(false);setPw1("");setPw2("");setPwErr("");}} style={{cursor:"pointer",fontSize:20,color:"#aaa"}}>✕</span>
            </div>
            <div style={{padding:"0 16px 8px"}}>
              <div style={{background:"#f7f7f7",borderRadius:12,padding:"12px 13px",marginBottom:10}}>
                <div style={{fontSize:10,color:"#999",fontFamily:"Inter,sans-serif",marginBottom:4,letterSpacing:"1px",textTransform:"uppercase"}}>{tr("set_pw_new_label")}</div>
                <input type="password" value={pw1} onChange={e=>setPw1(e.target.value)} placeholder={tr("set_pw_new_placeholder")} style={{border:"none",background:"transparent",fontSize:16,fontFamily:"Inter,sans-serif",fontWeight:600,width:"100%"}}/>
              </div>
              <div style={{background:"#f7f7f7",borderRadius:12,padding:"12px 13px",marginBottom:10}}>
                <div style={{fontSize:10,color:"#999",fontFamily:"Inter,sans-serif",marginBottom:4,letterSpacing:"1px",textTransform:"uppercase"}}>{tr("set_pw_repeat_label")}</div>
                <input type="password" value={pw2} onChange={e=>setPw2(e.target.value)} onKeyDown={e=>{if(e.key==="Enter")savePassword();}} placeholder={tr("set_pw_repeat_placeholder")} style={{border:"none",background:"transparent",fontSize:16,fontFamily:"Inter,sans-serif",fontWeight:600,width:"100%"}}/>
              </div>
              {pwErr&&<div style={{fontSize:11.5,color:"#D93025",fontFamily:"Inter,sans-serif",marginBottom:10}}>{pwErr}</div>}
            </div>
            <div style={{padding:"4px 16px 26px"}}>
              <div onClick={savePassword} style={{background:pw1.length>=6&&pw1===pw2?"linear-gradient(135deg,#FF2D6B,#7B2FFF)":"#eee",color:pw1.length>=6&&pw1===pw2?"#fff":"#aaa",padding:"13px",borderRadius:40,fontSize:14,fontWeight:700,fontFamily:"Inter,sans-serif",textAlign:"center",cursor:"pointer",opacity:pwBusy?.6:1}}>{pwBusy?tr("set_pw_saving"):tr("set_pw_save")}</div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
export function exportUserData(st){
  const payload={
    exportedAt:new Date().toISOString(),
    profile:st.profile,
    theme:st.myTheme,
    books:st.books,
    micro:st.micro,
    threads:st.threads,
    filters:st.filters.filter(f=>f.mine),
    rewards:st.rewards,
    settings:st.settings,
  };
  const blob=new Blob([JSON.stringify(payload,null,2)],{type:"application/json"});
  const url=URL.createObjectURL(blob);
  const a=document.createElement("a");
  a.href=url; a.download=`oncer-dati-${(st.profile.username||"utente")}.json`;
  document.body.appendChild(a); a.click(); document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
